module.exports = __webpack_public_path__ + "img/typography.f166e588.svg";